export const SELECTORS = {
    ADD: ".add-to-cart:is(.btn, x-dropdown-button)",
    CART_ITEM: ".cart .cart-item",
    VARIANT_SELECT: ".product-variant-picker",
    QUANTITY_SELECT: "x-quantity",
    ACTIVE_CHOICE: ".active",
    CART_ITEM_SERVICES: ".cart-item-services"
};

export const DATA_ATTRIBUTES = {
    CART_ITEM_KEY: "data-item-key",
    SERVICE_HANDLE: "data-service-handle",
    SERVICE_VARIANT: "data-service-variant",
    CHOICE: "data-choice"
};

export const SERVICE_PROPERTY_MAP: {
    [key: string]: { property?: string; className?: string; service_quantity?: string };
} = {
    "_versicherung-vollkasko": {
        property: "Hinweis",
        className: "sub-tax",
        service_quantity: "_insurance_quantity"
    },
    _handschuhe: {
        service_quantity: "_accessories_quantity"
    },
    "_jacke-nierengurt": {
        service_quantity: "_accessories_quantity"
    },
    _helm: {
        service_quantity: "_accessories_quantity"
    },
    _leihhelm: {
        service_quantity: "_accessories_quantity"
    },
    _leihschloss: {
        service_quantity: "_accessories_quantity"
    }
};

export const PRODUCT_TYPE_TESTRIDE = "Testride";
export const PRODUCT_TYPE_EBIKE = "E-Bike";
export const INSURANCE_TYPE_NOT_TESTRIDE = "Rental";
export const PRODUCT_TYPE_EBIKE_RENTAL = "E-Bike Rental";

export const RENTAL_TYPES = ["Bike Rental", "Motorbike Rental", PRODUCT_TYPE_TESTRIDE];
export const RENTAL_TYPES_EBIKE = [PRODUCT_TYPE_EBIKE_RENTAL];
export const BUYING_TYPES = ["Motorbike"];
export const BUYING_TYPES_EBIKE = [PRODUCT_TYPE_EBIKE];

export const META_PRODUCT_TYPES = ["Meta", "Vermietung Zubehör", "Vermietung Versicherung"];

export const SERVICE_BELONGS_TO_KEY = "_belongs_to";
export const PRODUCT_SERVICES_KEY = "_lim_services";
export const GUARANTEE_TYPES = {
    EBIKE: {
        GUARANTEE_LT_4000: "< 4000",
        GUARANTEE_GT_4000: "> 4000"
    },
    MOTORBIKE: {
        GUARANTEE_1000: "> 1000",
        GUARANTEE_900: "701-1000",
        GUARANTEE_126: "126-700",
        GUARANTEE_125: "<= 125"
    }
};
